<template>
	<div class="intro-container">
		<h1>Velkommen til<br />I sandhedens Tjeneste</h1>

		<p class="font-italic mt-3">Tryk for at oprette en klasseprofil</p>

		<div class="button-container">
			<ist-button widthType="block" type="red" v-on:click="start">Start</ist-button>
		</div>
	</div>
</template>

<script>
	import * as MutationTypes from '@/store/mutation-types'
	import {mapGetters} from 'vuex';
	import IstButton from '@/components/buttons/IstButton.vue';

	export default {
		name: 'client-intro-view',
		components: {
			IstButton,
		},
		methods: {
			start() {
				this.$router.push('/register');
			}
		},
	}
</script>

<style lang="scss" scoped>
	.intro-container {
		position: fixed;
		top: 50%;
		left: 50%;
		margin: 0;
		transform: translate(-50%, -50%);
	}

	.logo-container {
		text-align: center;

		margin: 0 auto;

		img {
			max-width: 200px;
		}
	}

	h1 {
		text-align: center;
		line-height: 100%;

		margin-bottom: 0;
	}

	p {
		text-align: center;
		font-size: 10pt;
	}

	.button-container {
		text-align: center;
	}
</style>
